import React from 'react';
import { Navigate } from 'react-router-dom';
import { canAccess } from '../utils/adminRole';

/**
 * ProtectedRoute Component
 * Protects admin routes based on role permissions
 * Redirects unauthorized users to dashboard
 */
export default function ProtectedRoute({ children, resource }) {
  // Optimistic check based on the cached display object (not proof of a
  // valid session — the httpOnly cookie is the real source of truth,
  // enforced server-side on every admin API call).
  const admin = sessionStorage.getItem('admin');
  
  // Not logged in - redirect to login
  if (!admin) {
    return <Navigate to="/admin/login" replace />;
  }
  
  // Check if user has access to this resource
  if (resource && !canAccess(resource)) {
    // User doesn't have permission - redirect to dashboard
    return <Navigate to="/admin/dashboard" replace />;
  }
  
  // User has permission - render the protected component
  return children;
}
